import logo from "../../assets/images/logo-dn.png";
const Logo =()=>{
    return (      
    <div className="logo" >
        <img className="logo" src={logo} alt="" />
    </div>
  )
}
export default Logo;